import { redirect } from '@tanstack/react-router'

/**
 * Where to go after signing in. Only same-site paths are allowed, so a crafted link cannot send
 * a freshly signed-in teacher to another site.
 */
export function safeRedirect(target: string | undefined | null, fallback = '/app'): string {
  if (!target) return fallback
  if (!target.startsWith('/') || target.startsWith('//') || target.includes('\\')) return fallback
  if ([...target].some((char) => char.charCodeAt(0) < 32)) return fallback
  return target
}

export function redirectToLogin(href: string) {
  return redirect({ to: '/login', search: { redirect: safeRedirect(href, '/app') } })
}
